// Corporate group subscriptions: $0 rows the backend creates for group members (mode_of_payment 'corporate').
// They're managed from the corporate group (member removal, group end date, group plan), so the user page treats them as read-only.

export const CORPORATE_MODE_OF_PAYMENT = 'corporate';

export const CORPORATE_SUBSCRIPTION_NOTE =
  'This subscription comes from a corporate group membership. To end it, remove the member from their group.';

export const isCorporateSubscription = sub =>
  !!sub && String(sub.mode_of_payment || '').toLowerCase() === CORPORATE_MODE_OF_PAYMENT;

// Lifetime access is stored as valid_to 9999-12-31.
export const isLifetimeValidTo = validTo => String(validTo || '').startsWith('9999');

export const formatValidTo = validTo => (isLifetimeValidTo(validTo) ? 'Lifetime' : validTo);
